import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  Chart,
  CategoryScale,
  LineController,
  BarController,
  BarElement,
  PointElement,
  Tooltip,
  Legend,
  LinearScale,
} from 'chart.js';

import { colors, gradients } from './defaults';

export default function BarChart({
  className,
  color,
  values,
  label,
  labels,
  gradient,
  hideLegend,
  barPercentage,
  min,
  max,
}) {
  const chartRef = useRef(false);
  const options = {
    plugins: {
      legend: {
        display: !hideLegend,
      },
      tooltip: {
        mode: 'index',
        intersect: false,
      },
    },
    scales: {
      xAxes: {
        grid: {
          display: false,
          border: false,
        },
        ticks: {
          fontSize: 12,
          color: '#97a4af',
          padding: 5,
        },
        categoryPercentage: 0.5,
      },

      yAxes: {
        min,
        max,
        grid: {
          color: '#e9ecef',
          drawBorder: false,
          zeroLineColor: '#e9ecef ',
        },
        ticks: {
          beginAtZero: true,
          fontSize: 12,
          color: '#97a4af',
          padding: 10,
        },
      },
    },
  };
  useEffect(() => {
    Chart.register(
      LineController,
      CategoryScale,
      BarController,
      BarElement,
      PointElement,
      LinearScale,
      Tooltip,
      Legend
    );

    const data = {
      labels,
      datasets: [
        {
          label,
          backgroundColor: gradient
            ? gradients(chartRef)[gradient]
            : colors[color],
          hoverBackgroundColor: gradient
            ? gradients(chartRef)[gradient]
            : colors[color],
          borderColor: gradient ? gradients(chartRef)[gradient] : colors[color],
          borderWidth: 0,
          data: values,
          barPercentage,
        },
      ],
    };
    Chart.defaults.font.family =
      'Poppins, system-ui, -apple-system, Roboto, Arial, system-ui, -apple-system, sans-serif';
    Chart.defaults.plugins.tooltip.padding = 10;
    Chart.defaults.plugins.tooltip.backgroundColor = 'rgba(0, 0, 0, 0.7)';
    Chart.defaults.scale.ticks.color = 'rgba(0, 0, 0, 0.4)';
    const chart = new Chart(chartRef.current, {
      type: 'bar',
      options,
      data,
    });
    return () => chart.destroy();
  }, [Legend, options]);
  return <canvas className={className} ref={chartRef} />;
}

BarChart.defaultProps = {
  labels: [],
  values: [],
  className: '',
  color: 'primary',
  label: 'Bar 01',
  gradient: '',
  hideLegend: true,
  barPercentage: 0.1,
  min: undefined,
  max: undefined,
};

BarChart.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.string),
  label: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.number),
  color: PropTypes.string,
  className: PropTypes.string,
  gradient: PropTypes.string,
  hideLegend: PropTypes.bool,
  barPercentage: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
};
